export default __webpack_public_path__ + "static/media/10.4bcc098b.jpeg";